/**
 * The figures of a BWA month in the order of the BWA. They are the fields of the GraphQL types
 * BwaFigures and BwaFiguresInput.
 */
export const bwaFigureNames = ['revenue', 'otherOperatingIncome', 'personnelCosts', 'hostingAndLicences', 'otherCosts', 'depreciation', 'incomeTaxes'] as const;

export type BwaFigures = Record<typeof bwaFigureNames[number], number>;
